import styled from 'styled-components';
import { FlexCenter } from 'Theme/mixins';

export const StyledButton = styled.button`
    ${FlexCenter};
    width: auto;
    border: none;
`;